import { FC } from 'react'
import { PrimaryHeading } from '@components/atoms/PrimaryHeading'
import { TokenPortfolioCard } from '@components/molecules/TokenPortfolioCard'
import { IUser } from '@/types'
import { getTokenLogo } from '@/utils'
import styles from './index.module.scss'

type Props = {
  user: IUser
}

export const TokenPortfolio: FC<Props> = ({ user }) => {
  return (
    <div>
      <div className={styles.heading}>
        <PrimaryHeading backgroundText='PORTFOLIO' htmlTagType='h2'>
          Token Portfolio
        </PrimaryHeading>
      </div>
      <div className={styles.content}>
        {user.profile?.tokens.map((token) => {
          return <TokenPortfolioCard key={token.id} logo={getTokenLogo(token)} name={token.name} />
        })}
      </div>
    </div>
  )
}
